export const NorthArrowBG = ({ props }) => {
  return (
    <svg
      style={{ ...props }}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        d="M23.4,12.6C23.4,18.9,18.3,24,12,24S0.6,18.9,0.6,12.6c0-5.1,3.3-9.5,8-10.9c0,0,0,0,0,0c0,0,0,0,0.1,0
	c0.1,0,0.1,0.1,0.1,0.2v1.3c0,0.1,0,0.1-0.1,0.2c0,0,0,0-0.1,0h0c-0.2,0-0.3,0.1-0.4,0.2C7,4,5.9,4.7,5,5.6C4.1,6.5,3.4,7.5,2.9,8.7
	c-0.5,1.3-0.8,2.5-0.8,3.9c0,1.4,0.3,2.7,0.8,3.9c0.5,1.1,1.2,2.2,2.1,3.1c0.9,0.9,2,1.6,3.1,2.2c1.3,0.5,2.5,0.8,3.9,0.8
	s2.7-0.3,3.9-0.8c1.1-0.5,2.2-1.2,3.1-2.1c0.9-0.9,1.6-1.9,2.1-3.1c0.5-1.3,0.8-2.5,0.8-3.9c0-1.4-0.3-2.7-0.8-3.9S19.9,6.5,19,5.6
	c-0.9-0.9-2-1.7-3.2-2.2c-0.2-0.1-0.3-0.1-0.5-0.2c-0.1,0-0.1-0.1-0.1-0.1V1.8c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0.1,0
	C20.1,3.1,23.4,7.5,23.4,12.6z M12.2,2l2.2,11.3c0,0.2,0,0.4,0,0.6L12.2,21c-0.1,0.2-0.3,0.2-0.4,0l-2.2-7.1c-0.1-0.2-0.1-0.4,0-0.6
	L11.8,2C11.8,1.8,12.2,1.8,12.2,2z M13.7,13.7h-3.3c-0.1,0-0.2,0.1-0.2,0.3l1.7,5.6c0.1,0.2,0.3,0.2,0.4,0l1.7-5.6
	C13.9,13.8,13.8,13.7,13.7,13.7z"
      />
    </svg>
  );
};

export const NorthArrowFG = ({ props }) => {
  return (
    <svg
      style={{ ...props }}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path d="m17.67,19.64l-5.67-2.05V6.78l5.67,12.86Zm-5.67-11.44l-4.57,10.43,4.57-1.65v-8.78m0-1.42v10.81l-5.67,2.05,5.67-12.86h0Z" />
    </svg>
  );
};
